module.exports = __webpack_public_path__ + "static/media/icon-piece6-7.f37a073f.png";